import { Component, ViewChild, OnInit, OnDestroy, HostListener } from '@angular/core';
import { HeaderService } from './tools/header.service';
import { MatSidenav } from '@angular/material/sidenav';
import { TranslateService } from '@ngx-translate/core';
import { Language } from './entities/Language';
import { Router, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { StorageService } from './tools/storage.service';
import { Utils } from './tools/utils';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { SITE_VERSION } from './entities/Constants';
import { ISize, IxellAPIService, Roles } from './tools/api.service';
import { DateAdapter } from '@angular/material/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    @ViewChild('sidenav') public sidenav: MatSidenav;
    // isCTC : boolean = false;
    // isAdmin : boolean = false;
    // isUser : boolean = false;
    private langue: Language;
    private langueSub: any;
    private tchatSub: any;
    private statsLogVisitSub: any;
    private translateSub: any;
    private roleSub: any;

    title = 'IxelColorLab';
    currentLanguage: string;
    // baseHref:any;
    displayCGUModal: boolean = false;
    actualYear = new Date().getFullYear();
    urlTchat: string;
    isTchat: boolean = false;

    baseHref: string;
    htmlString: any;

    displayUpdate: boolean = true;
    version: string;

    displayGoToTopButton: boolean = false;
    goToTopButtonOpacity: string = '0';

    displayCGUNav: boolean = false;

    role: Roles;

    constructor(private headerService: HeaderService, private translate: TranslateService, private router: Router, public storage: StorageService,
        private http: HttpClient, private sanitizer: DomSanitizer, private metaService: Meta, private apiService: IxellAPIService, private dateAdapter: DateAdapter<any>) {
        // Stats - Tracking des pages visités
        router.events.subscribe((event: NavigationEvent) => {
            if (event instanceof NavigationStart) {
                if (this.storage.get("token")) { // Seulement si l'utilisateur est connecté
                    this.statsLogVisitSub = this.apiService.statsLogVisit(event.url, new ISize({ width: window.innerWidth, height: window.innerHeight })).subscribe(data => {
                        if (this.statsLogVisitSub != null) this.statsLogVisitSub.unsubscribe();
                    });
                }
            }
        });
    }

    refreshCSSVariables() {
        let elem = document.getElementById("footerimg");
        if (elem.offsetParent === null)
            elem = document.getElementById("footerimg-m");

        const footerHeight = elem.clientHeight;
        const footerMarginHeight = document.getElementById("footermargin")?.clientHeight ?? 0;
        document.documentElement.style.setProperty("--footer-height", footerHeight + "px");
        document.documentElement.style.setProperty("--footer-margin", footerMarginHeight + "px");
        document.documentElement.style.setProperty("--header-height-resp", document.getElementById("header").clientHeight + "px");
        document.documentElement.style.setProperty("--vw", window.innerWidth + "px");
        document.documentElement.style.setProperty("--vh", window.innerHeight + "px");
    }

    ngAfterContentChecked() {
        this.refreshCSSVariables();
        this.checkTchat();
    }

    ngOnInit() {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                //returns installed service workers
                if (registrations.length) {
                    for (let registration of registrations) {
                        registration.unregister();
                    }
                }
            });
        }

        //this.currentLanguage = this.storage.get("actualLanguage");
        //if (this.currentLanguage)
        //  this.headerService.changeLangue(this.currentLanguage);
        //else {
        //  // Si la langue du navigateur est FR, met en fr sinon par défaut met en anglais
        //  this.currentLanguage = navigator.language.split('-')[0];
        //  if (this.currentLanguage == "fr") {
        //    this.headerService.changeLangue(this.currentLanguage);
        //    this.storage.set("actualLanguage", "fr");
        //  } else {
        //    this.translate.setDefaultLang('en');
        //    this.storage.set("actualLanguage", "en");
        //  }
        //}

        // CGU
        var base = document.getElementsByTagName('base');
        //this.baseHref = base != null && base.length != 0 ? "assets/AutoDec/CGU.html?environment=" + base[0].href : "assets/AutoDec/CGU.html?environment=" + "";
        this.baseHref = base[0].href + "assets/cgu/cgu";
        ///*----------------------------------------------------------------------------------------------------*/console.log("base : ", base); 
        ///*----------------------------------------------------------------------------------------------------*/console.log("base[0] : ", base[0]);
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.baseHref : ", this.baseHref);

        const request = this.http.get(this.baseHref + ".html", { headers: new HttpHeaders({ 'Content-Type': 'text/plain', }), observe: 'response', responseType: 'text' })
            .subscribe(res => this.htmlString = this.sanitizer.bypassSecurityTrustHtml(res.body));



        // @clemence Détecte langue navigateur 
        this.currentLanguage = navigator.language.split('-')[0];
        if (this.currentLanguage) {
            this.headerService.changeLangue(this.currentLanguage);
            this.storage.set("actualLanguage", this.currentLanguage);
        }
        // this.data.setSidenav(this.sidenav);
        this.langueSub = this.headerService.currentLangue.subscribe(langue => {
            this.langue = langue;
            if (langue != null) {
                this.translate.use(langue);
                this.dateAdapter.setLocale(langue);
            }
        });

        this.headerService.verifyRole();

        let products = JSON.parse(localStorage.getItem("cart"));
        if (products) {
            this.headerService.changeNbProduct(products.length);
            this.headerService.changeProducts(JSON.stringify(products));
        } else {
            this.headerService.changeNbProduct(0);
            this.headerService.changeProducts(null);
        }

        this.translate.get("home.intro").subscribe(data => {
            this.metaService.addTag({
                name: "description",
                content: data
            })
        });

        this.updateBandeauLang('fr');

        this.translateSub = this.translate.onLangChange.subscribe((e) => {
            this.updateBandeauLang(e.lang);
        });

        this.checkTchat();

        this.version = SITE_VERSION;


        //this.roleSub = this.headerService.currentRole.subscribe(role => {
        //    this.role = role;
        //    console.log("headerService role");
        //    console.log(role);
        //    if (this.roleSub != null) this.roleSub.unsubscribe();
        //}, error => {
        //    console.log(error);
        //    if (this.roleSub != null) this.roleSub.unsubscribe();
        //});

        ////var base = document.getElementsByTagName('base');
        ////this.baseHref = base[0].href + "assets/cgu/cgu";

        //console.log("role");
        //console.log(this.role);
    }

    updateBandeauLang(lang: string) {
        let img: HTMLImageElement = document.getElementById('footerslogan') as HTMLImageElement;
        if (!img)
            return;

        let target = `assets/bandeau/slogan/${lang}.png`;

        if (img.src != target)
            img.src = target;
    }

    fallbackBandeauLang() {
        this.updateBandeauLang('fr');
    }

    // Vérification si conversation tchat en cours
    checkTchat() {
        let urlTchat = sessionStorage.getItem("urlTchat");
        let token = sessionStorage.getItem("token");
        if (urlTchat && token != null) {
            this.isTchat = true;
            this.urlTchat = urlTchat;
        }
        else {
            this.isTchat = false;
        }
        //console.log("--- app-component token: ", token);
        //console.log("--- app-component isTchat: ", this.isTchat, "this.urlTchat ", urlTchat);
    }

    showCGU() {
        this.openCGU();
        this.onLoad();
        window.setTimeout(() => { this.onLoad(); }, 50);
        window.addEventListener("hashchange", () => { this.onHashChange(); });
    }

    querySelectorAllPolyfill(r: any) { //, c: any, i: any, j: any, a: any) {
        var d = document;
        var s = (<any>d).createStyleSheet();
        var a: any = d.all;
        var c: any = []
        var r: any = r.replace(/\[for\b/gi, '[htmlFor').split(',');
        for (var i = r.length; i--;) {
            s.addRule(r[i], 'k:v');
            for (var j = a.length; j--;) a[j].currentStyle.k && c.push(a[j]);
            s.removeRule(0);
        }
        return {
            item: (index: any) => { return c[index]; },
            results: c
        };
    }

    getParamsInURL() {
        //var params = location.href.split('?')[1].split('&');
        //data = {};
        //for (x in params)
        //{
        // return window.open(data[params[x].split('=')[1]] = params[x].split('=')[1] + url);
        //}
        window.open(this.baseHref + ".pdf");
    }

    IsCSSStickySupported() {
        var _el = document.createElement('a');
        var _style = _el.style;
        _style.cssText = "position:sticky;position:-webkit-sticky;position:-ms-sticky;";
        return _style.position.indexOf('sticky') !== -1;
    }

    jssPropertySupported(properties: any) {

        var element = document.createElement('a');
        var _styles = window.getComputedStyle ? window.getComputedStyle(element) : (<any>element).currentStyle;
        var index = properties.length;
        try {
            while (index--) {
                var name = properties[index];
                if (_styles[name] != undefined) {
                    return name;
                }
            }
        } catch (pError) { }
        return false;
    }

    hasClass(element: Element, classString: string) {
        var _test = (element.className ? element.className : "").match(new RegExp(classString, "g"));
        if (!_test) return false;
        return true;
    }

    addClass(element: Element, classString: string) {
        if (!this.hasClass(element, classString)) {
            element.className = element.className + " " + classString;
        }
    }

    removeClass(element: Element, classString: string) {
        element.className = element.className.split(classString).join("");
    }

    IsMediumScreen() {
        return document.documentElement.clientWidth >= 1024;
    }

    IsSmallScreen() {
        return document.documentElement.clientWidth >= 560;
    }

    _findTreeSection(element: any) {
        var _el: any = [];
        if (!element) return _el;
        var _children = element.children;
        if (_children == undefined) return _el;
        _children = _children[0].children;
        if (_children == undefined) return _el;
        for (var i = 0; i < element.children.length; i++) {
            var _elem = element.children[i];
            if (_elem.tagName.toLowerCase() == "section") {
                var _anchor = _elem.children.item(0);
                var _title = _elem.children.item(1);
                var _content = _elem.children.item(2);
                if (!_anchor || _anchor.tagName.toLowerCase() != "a") break;
                _el.push({
                    anchorNode: _anchor,
                    titleNode: _title,
                    contentNode: _content,
                    link: _anchor.name,
                    text: _title.innerText,
                    children: this._findTreeSection(_content)
                })
            }

        }
        return _el;
    }

    toggleCGUNav() {
        this.displayCGUNav = !this.displayCGUNav;
    }

    cguLangChange() {
        setTimeout(() => this.onLoad(), 50);
    }

    _createSectionMenu(elements: any) {
        if (!elements || elements.length == 0) return undefined;
        let _ul = document.createElement("ul");
        for (let i = 0; i < elements.length; i++) {
            let _element = elements[i];

            let _li = document.createElement("li");

            let _a = document.createElement("a");
            _a.innerText = _element.text;
            _a.style.cursor = 'pointer';
            _a.addEventListener('click', () => {
                document.querySelector(`a[name="${_element.link}"`)?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                this.toggleCGUNav();
            });

            let _childUl = this._createSectionMenu(_element.children);

            _li.appendChild(_a);
            if (_childUl) _li.appendChild(_childUl);
            _ul.appendChild(_li);
        }
        return _ul;
    }

    print() {
        this.addClass(document.body, "print");
        window.print();
        setTimeout(() => { this.removeClass(document.body, "print") }, 10);
    }

    openMenu(open: boolean) {
        var cguMenu = document.querySelectorAll(".cgu-menu").item(0);
        var _open = false;

        if (open == undefined) {
            if (!this.hasClass(cguMenu, "show")) _open = true; else _open = false;
        } else {
            _open = open;
        }

        if (_open) {
            this.addClass(cguMenu, "show");
            if (!this.IsSmallScreen()) this.addClass(document.body, "no-scroll");
        } else {
            this.removeClass(cguMenu, "show");
            this.removeClass(document.body, "no-scroll");
        }
    }

    onLoad() {
        //querySelectorAll polyfill
        if (!document.querySelectorAll) (<any>document).querySelectorAll = this.querySelectorAllPolyfill;

        //sticky supported
        if (!this.IsCSSStickySupported()) {
            if (window.addEventListener) {
                window.addEventListener("scroll", this.onScroll);
            } else {
                window.addEventListener("onscroll", this.onScroll);
            }
        }

        // test css flexbox
        if (this.jssPropertySupported(['msFlex', 'flex']) === false)
            this.addClass(document.body, "no-flexbox");

        //media queries supported ?
        if ((<any>window).CSSMediaRule == undefined) {
            if (window.addEventListener) {
                window.addEventListener("resize", () => { this.addMediaWidthClasses(); });
            } else {
                window.addEventListener("onresize", () => { this.addMediaWidthClasses(); });
            }
            this.addMediaWidthClasses();
        }

        // menu
        var _cgu = document.querySelectorAll(".cgu").item(0);
        var _cguBody = document.querySelectorAll(".cgu-body").item(0);
        var _cguMenu = document.querySelectorAll(".cgu-menu").item(0);
        var _cguMenuSections = document.getElementById("cgu-menu-sections");
        if (!_cgu || !_cguBody || !_cguMenu || !_cguMenuSections) return;

        // récupération des sections
        var _treeSections = this._findTreeSection(_cguBody);
        // création du menu
        var _ulTree = this._createSectionMenu(_treeSections);
        // ajout dans le DOM
        while (_cguMenuSections.firstChild) {
            _cguMenuSections.removeChild(_cguMenuSections.firstChild);
        }
        _cguMenuSections.appendChild(_ulTree);
    }

    onHashChange() {
        this.openMenu(false);
    }

    addMediaWidthClasses() {
        let _width = document.documentElement.clientWidth;
        this.removeClass(document.body, "media-560");
        this.removeClass(document.body, "media-1024");
        if (_width >= 560) this.addClass(document.body, "media-560");
        if (_width >= 1024) this.addClass(document.body, "media-1024");
    }

    onResize() {
        this.addMediaWidthClasses();
        this.refreshCSSVariables();
    }

    onScroll() {
        // use for 1024px client width
        if (document.documentElement.clientWidth < 1024) return;
        var _cguBody = document.querySelectorAll(".cgu-body").item(0);
        if (!_cguBody) return;
        var _rect = _cguBody.getBoundingClientRect();
        //var _scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
        if (_rect.top < 0) {
            this.addClass(document.body, "sticky-hack");
        } else {
            this.removeClass(document.body, "sticky-hack");
        }
    }

    ngOnDestroy(): void {
        if (this.langueSub != null) this.langueSub.unsubscribe();
        if (this.statsLogVisitSub != null) this.statsLogVisitSub.unsubscribe();
        if (this.translateSub != null) this.translateSub.unsubscribe();
    }

    sidenavToggle() {
        let hasBeenChecked: string = this.storage.get("hasBeenChecked");
        if (Utils.IsNullOrWhiteSpace(hasBeenChecked)) {
            // une déconnexion peut avoir eu lieu : reset des valeurs
            this.resetValues();
            this.storage.set("hasBeenChecked", "1");
        }
        this.sidenav.toggle();
    }

    resetValues() {
    }

    openCGU() {
        this.onLoad();
        this.displayCGUModal = true;
        let modal = document.getElementById("ModalCGU");
        modal.style.display = "flex";
    }

    closeCGU() {
        let modal = document.getElementById("ModalCGU");
        modal.style.display = "none";
    }

    destroy(): void {
        setTimeout(() => { this.displayUpdate = false; }, 1);
    }

    refreshGoToTopButton(event: UIEvent) {
        const sT = (event.currentTarget as HTMLElement).scrollTop;
        this.displayGoToTopButton = (sT >= 10);
        this.goToTopButtonOpacity = Math.max(0, Math.min((sT - 10) / 100, 1)).toFixed(2);
    }
}
